<template>
  <!-- PAGE CONTENT BEGINS -->
  <div style="">
        <div style="height: 100%;width: 100%;">
          <div class="box">
            <el-form ref="form" :inline="true" label-width="100px" size="small">
              <el-form-item>
                <el-select clearable v-model="state2" placeholder="审核状态" style="width: 200px">
                  <el-option :value="0" label="未审核"/>
                  <el-option :value="1" label="审核通过" />
                  <el-option :value="2" label="审核驳回" />
                </el-select>
              </el-form-item>
            </el-form>
            <div>
              <el-button size="small" @click="list(1)" type="primary" plain icon="el-icon-search">搜索</el-button>
              <el-button size="small" @click="batchRefurbish=true" type="primary" plain icon="el-icon-refresh">批量翻新</el-button>
              <el-button size="small" @click="exportExcel" type="primary" plain icon="el-icon-download" >下载 </el-button>
            </div>
          </div>
          <el-table  ref="tableData" :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
                    :cell-style="{height:'5px,0',textAlign:'center'}"
                    :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                    border style="height: 70vh">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="operationName" label="操作名称" width="100">
            </el-table-column>
            <el-table-column prop="openid" label="客户openId" width="300">
            </el-table-column>
            <el-table-column prop="mobile" label="客户手机号" width="150">
            </el-table-column>
            <el-table-column prop="balance" label="清空金额" width="100">
            </el-table-column>
            <el-table-column prop="iccid" label="ICCID" width="200">
            </el-table-column>
            <el-table-column prop="ordNo" label="订单号" width="200">
            </el-table-column>
            <el-table-column prop="createUser" label="提交人" width="100">
            </el-table-column>
            <el-table-column prop="createTime" label="提交时间" width="200">
            </el-table-column>
            <el-table-column prop="state" label="审核状态" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.state===0">未审核</div>
                <div v-if="scope.row.state===1" >审核通过</div>
                <div v-if="scope.row.state===2" >审核驳回</div>
              </template>
            </el-table-column>
            <el-table-column prop="refundInfo" label="驳回原因" width="100">
            </el-table-column>
            <el-table-column prop="updateUser" label="审核人" width="100">
            </el-table-column>
            <el-table-column prop="updateTime" label="审核时间" width="200">
            </el-table-column>

            <el-table-column fixed="right" label="操作" min-width="150">
              <template slot-scope="scope">
                <el-button v-if="scope.row.state===0"  style="color:red;" @click="reapplyRefund(scope.row)" type="text">执行
                </el-button>
                <el-button  v-if="scope.row.state===0"  @click="reapplyRefundNo(scope.row)" type="text">驳回
                </el-button>
                <el-button v-if="scope.row.state===1"   size="mini" type="text">审核通过
                </el-button>
                <el-button v-if="scope.row.state===2" style="color: green"  size="mini" type="text">审核驳回
                </el-button>
              </template>
            </el-table-column>

          </el-table>

          <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>
          <!--</div>-->
        </div>

    <el-dialog :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false"  title="批量翻新"
               :visible.sync="batchRefurbish" width="30%">
      <el-form :model="queryCharge" ref="queryCharge">
        <div >
          <el-form>
            <el-form-item  label="ICCID：">
              <el-input style="width: 100%;" type="textarea" name="content" id="content" rows="10" v-model="queryCharge.iccids" placeholder="请输入ICCID（卡号之间以换行隔开）">
              </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" style="margin-bottom: 2%;text-align: end">
            <el-button type="info" size="small" @click="cancel">取 消</el-button>
            <el-button :disabled="queryCharge.disabled" plain size="small" type="primary" @click.stop="refurbish" >确 定</el-button>
          </div>
        </div>
      </el-form>

    </el-dialog>
  </div>

</template>

<script>
import Pagination from '../../../components/pagination'
import card_info from "../card/card";
import tools from "../../../utils/tools";

export default {
  name: 'wechatUser',
  components: { Pagination ,card_info},
  mounted: function () {
    let _this = this
    this.list(1)
    _this.$refs.pagination.size = 10
  },
  data() {

    return {
      state2: '',
      startTime: '',
      endTime: '',
      tableData: [],
      openid:'',
      serviceProcessjs: require("../../../api/serviceProcess"),
      batchRefurbish:false,
      queryCharge:{
        iccids: [],
        disabled: false,
      },
    }
  },
  methods: {
    exportExcel(){
      let _this = this
      _this.$confirm('由于导出数据需要一定时间，请确定是否需要下载。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data={
          state:_this.state2===''?-1:this.state2
        }
        _this.serviceProcessjs.exportExcel( data)
                .then(res => {
                  _this.$alert('已操作导出，请稍后到功能模块：业务管理中的执行任务管理下载查看！')
                })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消！'
        })
      })
    },
    refurbish() {
      let _this = this
      _this.queryCharge.iccids = tools.textareaGet(_this.queryCharge.iccids)
      if (_this.queryCharge.iccids.length === 0) {
        _this.$alert("请输入卡号")
        return false
      }
      if (_this.queryCharge.iccids.length > 500) {
        _this.$alert("最多只能输入500张卡号")
        return false
      }
      _this.queryCharge.disabled = true
      _this.serviceProcessjs.batchRefurbish(_this.queryCharge)
              .then(res => {
                if (res.data.code === '0') {
                  _this.$alert(res.data.data)
                } else {
                  _this.$alert(res.data.msg)
                }
                _this.batchRefurbish = false
                _this.loading = false
                _this.queryCharge = _this.$options.data().queryCharge
              })
              .catch(err => {
                _this.$swal(err + '网络异常')
                _this.batchRefurbish = false
                _this.queryCharge = _this.$options.data().queryCharge
              })
    },
    cancel() {
      let that = this
      that.queryCharge.iccids = []
      that.batchRefurbish = false
    },
    reapplyRefundNo(info){
      let _this=this
      _this.$prompt('请输入驳回原因', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        if(null==value || ""==value){
          _this.$alert("请输入驳回原因")
          return false
        }
        info.refundInfo = value
        info.state = 2
        _this.serviceProcessjs.actionServiceProcess(info)
                .then(response=>{
                  if(response.data.code==='0'){
                    _this.$alert(response.data.data)
                  }else{
                    _this.$alert(response.data.msg)
                  }
                }).catch(err=>{

        })
      }).catch(() => {

      });
    },
    reapplyRefund(info){
      let _this = this
      info.state = 1
      _this.$confirm('确定执行'+info.operationName+'操作', '是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        info.actionState=1
        _this.serviceProcessjs.actionServiceProcess(info)
                .then(response=>{
                  if(response.data.code==='0'){
                    _this.$alert(response.data.data)
                    this.reapplyRefundDis = false
                  }else{
                    _this.$alert(response.data.msg)
                  }
                }).catch(err=>{

        })
      }).catch(() => {

      });

    },
    list(page) {
      let _this = this
      let data={
        current: page,
        size: _this.$refs.pagination.size,
        state:_this.state2===''?-1:this.state2
      }
      _this.serviceProcessjs.getServiceProcess(data)
        .then(response => {
          _this.tableData = response.data.data.rows
          _this.$refs.pagination.render(page, response.data.data.total)
        })
    },
  }
}
</script>

<style lang="less" scoped>

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
  .el-table__body-wrapper {
    height: calc(100% - 48px) !important; // 表格高度减去表头的高度
  overflow-y: auto;
  }
  }

  ::v-deep .el-button-group .el-button {
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
  }

/deep/.el-input {
  width: 90%;
}
/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}
.box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.btns {
  margin-left: 30px;
}
.el-form--inline .el-form-item {
  margin-right: -10px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 5px;
}


</style>
